import {AppStore} from "../../desktop";
import {Department} from "../../models/Department";
import {DepartmentsActionTypes} from "./types";
import {TabsActionTypes} from "../tabs";

export const actionDepartmentsFetchAll = () => {
	AppStore.dispatch({type: DepartmentsActionTypes.FETCH_ALL_REQUEST, payload: null})
}

export const actionDepartmentsFetchAllCompleted = (departments: Department[]) => {
	AppStore.dispatch({type: DepartmentsActionTypes.FETCH_ALL_COMPLETED, payload: departments})
}

export const actionDepartmentsFetch = (departments: Department) => {
	AppStore.dispatch({type: DepartmentsActionTypes.FETCH_ONE_REQUEST, payload: departments})
}

export const actionDepartmentsFetchCompleted = (departments: Department) => {
	AppStore.dispatch({type: DepartmentsActionTypes.FETCH_ONE_COMPLETED, payload: departments})
	AppStore.dispatch({type: TabsActionTypes.SET_TAB_ITEM, payload: departments})
}

export const actionDepartmentsSave = (departments: Department) => {
	AppStore.dispatch({type: DepartmentsActionTypes.SAVE_REQUEST, payload: departments})
}

export const actionDepartmentsSaveCompleted = (departments: Department) => {
	AppStore.dispatch({type: DepartmentsActionTypes.SAVE_COMPLETED, payload: departments})
}

export const actionDepartmentsDelete = (departments: Department) => {
	AppStore.dispatch({type: DepartmentsActionTypes.DELETE_REQUEST, payload: departments})
}

export const actionDepartmentsDeleteCompleted = (departments: Department) => {
	AppStore.dispatch({type: DepartmentsActionTypes.DELETE_COMPLETED, payload: departments})
}

export const actionDeleteDepartments = (departments: Department[]) => {
	AppStore.dispatch({type: DepartmentsActionTypes.DELETE_MULTIPLE_REQUEST, payload: departments})
}

export const actionDeleteDepartmentsCompleted = (departments: Department[]) => {
	AppStore.dispatch({type: DepartmentsActionTypes.DELETE_MULTIPLE_COMPLETED, payload: departments})
}
